var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-company"},[_c('span',{staticClass:"cntitle"},[_vm._v(_vm._s(_vm.mainWord2.chTitle))]),_vm._v(" "),_c('div',{staticClass:"introduct-im"},_vm._l((_vm.mainImg),function(item){return _c('div',{staticClass:"imgwrapper"},[_c('img',{attrs:{"src":'static/image/serive-img/' + item + '.jpg'}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbf762f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab-item/second-company.vue
// module id = null
// module chunks = 